'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _nuiShell = require('@concur/nui-shell');

var _actions = require('./modules/actions');

var Actions = _interopRequireWildcard(_actions);

var _analytics = require('../constants/analytics');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getAppDimensions = function getAppDimensions(state) {
  return {
    // things to track, such as user id, listing id, listing name and compnay uuid.
    // Pull them in from state.
  };
};

var interactionEventActions = _defineProperty({}, Actions.ANALYTICS_INTERACTION_EVENT, function (_ref) {
  var payload = _ref.payload;
  return _extends({}, payload);
});

exports.default = _nuiShell.analyticsEvents.createMapStateToAnalytics({
  applicationName: _analytics.APPLICATION_NAME,
  getAppDimensions: getAppDimensions,
  interactionEventActions: interactionEventActions
});


//////////////////
// WEBPACK FOOTER
// ./lib/analytics/analytics.js
// module id = 553
// module chunks = 0